<div class="fx-layout-row fx-gap--64px--gt-sm fx-gap--32px--lt-md">
  <div class="info fx-flex--50 hide-xs">
    @if (!showVideo) {
      <img [src]="'/assets/images/help/' + (project.primaryProduct == 'MAT' ? 'mat-layers.png' : 'outer-size.png')" [alt]="(project.primaryProduct == 'MAT' ? 'Matboard Layers' : 'Matboard Outer Size')"/>
    }
    @if (showVideo) {
      <div class="video-container">
        <iframe src="https://www.youtube.com/embed/Ga7374SL1IA" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    }
    @if (!showVideo) {
      <button mat-button="" (click)="showVideo=true">
        <mat-icon svgIcon="video"></mat-icon>
        See Measuring Guide
      </button>
    }
    @if (showVideo) {
      <button mat-button="" (click)="showVideo=false">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        Go Back
      </button>
    }
  </div>
  @if (project) {
    <mbnm-builder-tile-group #tiles class="size-selector fx-flex--50 fx-flex--100--xs">
      <mbnm-builder-tile [title]="tileData.outer.heading" [collapsible]="false"
        [helpInfo]="tileData.outer.helpInfo"
        [secondary]="secondary" [leftAlign]="!secondary">
        @if (!project.restrictions?.outerSizeLocked) {
          <div class="content">
            <div class="flex-center">
              <div class="lazy-select-wrapper">
                <div>width</div>
                <mbnm-lazy-size-select [range]="project.size.widthRange" [(ngModel)]="project.size.width"
                  [disabled]="project.numOpenings > 0 && project.opening.size.partiallyComplete"
                  extraMessaging="<strong>Missing Outer Size?</strong><p>If you have an opening size, try shrinking it to see if additional outer sizes become available.</p><p>Max Outer Size is 32&#34; x 40&#34;.</p>"
                  disabledMessaging="Please complete your opening size selection before choosing an outer size.">
                </mbnm-lazy-size-select>
              </div>
              <div class="swap-button thick-icon">
                @if (!project.size.incomplete && !project.permanentDesignId) {
                  <button class="extra-small" mat-mini-fab color="secondary" (click)="rotateOuterIfPossible($event)" style="margin-top:-6px">
                    <mat-icon aria-label="rotate opening" svgIcon="swap"></mat-icon>
                  </button>
                }
              </div>
              <div class="lazy-select-wrapper">
                <div>height</div>
                <mbnm-lazy-size-select [range]="project.size.heightRange" [(ngModel)]="project.size.height"
                  [disabled]="project.numOpenings > 0 && project.opening.size.partiallyComplete"
                  extraMessaging="<strong>Missing Outer Size?</strong><p>If you have an opening size, try shrinking it to see if additional outer sizes become available.</p><p>Max Outer Size is 32&#34; x 40&#34;.</p>"
                  disabledMessaging="Please complete your opening size selection before choosing an outer size.">
                </mbnm-lazy-size-select>
              </div>
            </div>
            <a (click)="showStandardSizes()">Choose a Standard Size</a>
          </div>
        }
        @if (project.restrictions?.outerSizeLocked) {
          <div class="content">
            {{ project.size | size | inches }}
          </div>
        }
      </mbnm-builder-tile>
      @if (!project.design && (project.primaryProduct == 'MAT' || project.topMat)) {
        <mbnm-builder-tile [title]="tileData.opening.heading" [collapsible]="false"
          [helpInfo]="tileData.opening.helpInfo"
          [secondary]="secondary" [leftAlign]="!secondary"
          >
          <div class="content">
            @for (opening of project.openings; track opening) {
              <div class="flex-center">
                @if (opening.restrictions?.positionLocked) {
                  <i>{{ opening.size.toString() }}</i>
                  @if (opening.shape && opening.shape[0]) {
                    <i> {{ opening.shape[0].description }}</i>
                    } Opening
                    @if (opening.left && opening.top) {
                      <i>
                        at ({{ opening.left | size | inches }},{{ opening.top | size | inches }})
                      </i>
                    }
                  }
                  @if (!opening.restrictions?.positionLocked) {
                    <div class="lazy-select-wrapper">
                      <div>width</div>
                      <mbnm-lazy-size-select [range]="project.opening.size.widthRange" [(ngModel)]="project.opening.size.width"
                        [disabled]="project.size.partiallyComplete"
                        [extraOptions]="[{value: 0, text: 'No Opening'}, {value: 0, text: '0&#8221;'}]" (change)="openingSizeDimensionChanged($event, 'width')"
                        extraMessaging="<strong>Missing Opening Size?</strong><p>Try expanding your outer size to see if more opening sizes become available.</p><p>Max Opening Size is 30&#34; x 38&#34;.</p>"
                        disabledMessaging="Please complete your outer size selection before choosing an opening size.">
                      </mbnm-lazy-size-select>
                    </div>
                    <div class="swap-button thick-icon">
                      @if (!project.size.incomplete && !project.permanentDesignId) {
                        <button class="bottom-right extra-small" mat-mini-fab color="secondary" (click)="rotateOpeningIfPossible($event)" style="margin-top:-6px">
                          <mat-icon aria-label="rotate opening" svgIcon="swap"></mat-icon>
                        </button>
                      }
                    </div>
                    <div class="lazy-select-wrapper">
                      <div>height</div>
                      <mbnm-lazy-size-select [range]="project.opening.size.heightRange" [(ngModel)]="project.opening.size.height"
                        [disabled]="project.size.partiallyComplete"
                        [extraOptions]="[{value: 0, text: 'No Opening'}, {value: 0, text: '0&#8221;'}]" (change)="openingSizeDimensionChanged($event, 'height')"
                        extraMessaging="<strong>Missing Opening Size?</strong><p>Try expanding your outer size to see if more opening sizes become available.</p><p>Max Opening Size is 30&#34; x 38&#34;.</p>"
                        disabledMessaging="Please complete your outer size selection before choosing an opening size.">
                      </mbnm-lazy-size-select>
                    </div>
                  }
                </div>
              }
              @if (project.restrictions?.openingPositionsLocked && project.numOpenings == 0) {
                <div class="flex-center openings-toolbar">
                  No Openings
                </div>
              }
              @if (!project.restrictions?.openingPositionsLocked && project.numOpenings == 0) {
                <div class="flex-center openings-toolbar">
                  <!--
                  <button *ngIf="project.numOpenings > 0 && project.primaryProduct == 'MAT'" mat-flat-button color="secondary-subtle" (click)="project.clearOpenings()">
                    {{ secondary ? 'Remove' : 'Remove Opening' }}
                  </button>
                  -->
                  <button mat-flat-button color="secondary" (click)="createOpening()">
                    Add Opening
                  </button>
                </div>
              }
            </div>
          </mbnm-builder-tile>
        }
        @if (!project.design && (project.primaryProduct == 'MAT' || project.topMat)) {
          <mbnm-builder-tile [title]="tileData.openingShape.heading" [collapsible]="false"
            [helpInfo]="tileData.openingShape.helpInfo"
            [secondary]="secondary" [leftAlign]="!secondary"
            >
            <div class="content">
              @if (project.design) {
                <div class="flex-center no-opening">
                  Custom Opening(s)
                </div>
              }
              @if (project.numOpenings === 0) {
                <div class="flex-center no-opening">
                  No Opening (Full Sheet)
                </div>
              }
              @if (project.numOpenings > 0) {
                <div class="flex-center no-opening">
                  <div class="select-wrapper">
                    <mbnm-shape-selector [project]="project">
                    </mbnm-shape-selector>
                  </div>
                </div>
              }
              <div class="flex-center multi-opening-upsell">
                <div>
                  More Openings?<br />
                  Additional Shapes?
                </div>
                <button mat-flat-button="" color="secondary" (click)="learnMoreClicked()">
                  Learn More
                </button>
              </div>
            </div>
          </mbnm-builder-tile>
        }
        @if (project.numOpenings === 1 && !project.size.incomplete && !project.opening.size.incomplete) {
          <mbnm-builder-tile [title]="tileData.bottomMargin.heading"
            [collapsible]="false" [helpInfo]="tileData.bottomMargin.helpInfo"
            [secondary]="secondary" [leftAlign]="!secondary" >
            <div class="content">
              <div class="flex-center">
                <div class="lazy-select-wrapper">
                  <mbnm-lazy-size-select [range]="project.availableBottomMargins" [(ngModel)]="project.bottomMargin"
                    [extraOptions]="project.specialBottomMargins">
                  </mbnm-lazy-size-select>
                </div>
              </div>
              @if (project.centeredMargins.height == project.bottomMargin) {
                <div class="bottom-margin-indicator">
                  (Centered)
                </div>
              }
              @if (project.bottomMargin == project.topCenterBottomMargin && project.topCenterBottomMargin !== project.centeredMargins.height) {
                <div class="bottom-margin-indicator">
                  (Top Centered)
                </div>
              }
            </div>
          </mbnm-builder-tile>
        }
        @if (project.numMats > 1 && project.opening && !project.opening.size.incomplete) {
          <mbnm-builder-tile [title]="tileData.reveal.heading" [collapsible]="false"
            [helpInfo]="tileData.reveal.helpInfo"
            [secondary]="secondary" [leftAlign]="!secondary">
            <div class="content">
              <mat-form-field class="reveal">
                <mat-select panelWidth="" [(ngModel)]="project.reveal">
                  <mat-select-trigger>
                    {{ project.reveal | size:'multichar' | inches }}
                  </mat-select-trigger>
                  @for (reveal of project.availableReveals.asArray; track reveal.value) {
                    <mat-option [value]="reveal.value">
                      {{ reveal.value | size:'multichar' | inches }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </mbnm-builder-tile>
        }
      </mbnm-builder-tile-group>
    }
  </div>
